import { OnboardingFlow } from '../components/OnboardingFlow';

export default function OnboardingPage({ onComplete }) {
  return <OnboardingFlow onComplete={onComplete} />;
}
